(function () {
  'use strict';

  // ── Product data from Shopify (injected by index.liquid / collection.liquid) ──
  var rawShopifyProducts = window.SHOPIFY_PRODUCTS || [];
  var SIZES = ['S', 'M', 'L', 'XL', '2XL'];

  // Normalize Shopify product format → our internal format
  var products = rawShopifyProducts.map(function (p) {
    var sizeInventory = {};
    var variantMap = {};
    (p.variants || []).forEach(function (v) {
      var sz = v.option1 || v.title;
      var qty = typeof v.inventory_quantity === 'number' ? v.inventory_quantity : (v.available ? 99 : 0);
      sizeInventory[sz] = v.available ? Math.max(qty, 0) : 0;
      variantMap[sz] = v.id;
    });
    var priceRaw = p.variants && p.variants[0] ? parseInt(p.variants[0].price, 10) : 0;
    var priceDollars = priceRaw / 100;
    var priceDisplay = '$' + (Number.isInteger(priceDollars) ? priceDollars : priceDollars.toFixed(2));
    var images = (p.images || []).map(function (img) { return img.src || img; });
    return {
      id: p.id,
      name: p.title,
      price: priceDisplay,
      priceNum: priceDollars,
      image: images[0] || '',
      images: images,
      desc: p.body_html ? p.body_html.replace(/<[^>]*>/g, '').trim() : '',
      sizeInventory: sizeInventory,
      variantMap: variantMap,
      available: p.available !== false,
    };
  });

  // ── Nav scroll ────────────────────────────────────────────────────
  window.addEventListener('scroll', function () {
    var nav = document.getElementById('mainNav');
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  });

  // ── Smart anchor navigation ───────────────────────────────────────
  // If the anchor target exists on this page → smooth-scroll to it.
  // If it doesn't exist (non-homepage) → navigate to homepage with hash.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      link.addEventListener('click', function (e) {
        var targetEl = document.querySelector(hash);
        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          e.preventDefault();
          window.location.href = '/' + hash;
        }
      });
    });
  });

  // ── Render product grid ───────────────────────────────────────────
  function renderProducts() {
    var grid = document.getElementById('productGrid');
    if (!grid) return;
    grid.innerHTML = '';

    if (!products.length) {
      // Coming-soon placeholder cards
      for (var cs = 0; cs < 3; cs++) {
        var csWrap = document.createElement('div');
        csWrap.className = 'card-wrap';
        csWrap.innerHTML =
          '<div class="product-card">' +
            '<div class="coming-soon-inner">' +
              '<div class="coming-soon-star">★</div>' +
              '<div class="coming-soon-text">New Drop<br>Coming Soon</div>' +
            '</div>' +
          '</div>' +
          '<div class="product-info">' +
            '<div class="product-name">MEMBERS Drop</div>' +
            '<div class="product-price">Dropping Soon</div>' +
          '</div>';
        grid.appendChild(csWrap);
      }
      return;
    }

    products.forEach(function (p, idx) {
      var wrap = document.createElement('div');
      wrap.className = 'card-wrap';
      wrap.style.cursor = 'pointer';

      var card = document.createElement('div');
      card.className = 'product-card';

      if (idx === 0) {
        var badge = document.createElement('div');
        badge.className = 'badge-new';
        badge.textContent = 'New';
        card.appendChild(badge);
      }
      if (!p.available) {
        var soldTag = document.createElement('div');
        soldTag.className = 'sold-out-tag';
        soldTag.textContent = 'Sold Out';
        card.appendChild(soldTag);
      }

      var thumb = p.images.length > 0 ? p.images[0] : '';
      if (thumb) {
        var imgWrap = document.createElement('div');
        imgWrap.className = 'product-img';
        var imgEl = document.createElement('img');
        imgEl.src = thumb;
        imgEl.alt = p.name;
        imgEl.loading = 'lazy';
        imgWrap.appendChild(imgEl);
        card.appendChild(imgWrap);
      } else {
        var swatchWrap = document.createElement('div');
        swatchWrap.className = 'product-color-swatch';
        var swatch = document.createElement('div');
        swatch.className = 'swatch-circle';
        swatch.style.background = '#333';
        swatchWrap.appendChild(swatch);
        card.appendChild(swatchWrap);
      }

      var overlay = document.createElement('div');
      overlay.className = 'product-overlay';
      overlay.innerHTML =
        '<div class="product-name-overlay">' + p.name + '</div>' +
        '<div class="product-price-overlay">' + p.price + '</div>' +
        '<button class="product-cta">★ View &amp; Buy</button>';
      card.appendChild(overlay);

      (function (capturedIdx) {
        wrap.addEventListener('click', function () { openGalleryModal(capturedIdx); });
      })(idx);

      wrap.appendChild(card);

      var info = document.createElement('div');
      info.className = 'product-info';
      info.innerHTML =
        '<div class="product-name">' + p.name + '</div>' +
        '<div class="product-price">' + p.price + '</div>';
      wrap.appendChild(info);

      grid.appendChild(wrap);
    });
  }

  renderProducts();

  // Auto-open product modal if flagged (product.liquid page)
  if (typeof window.OPEN_PRODUCT_IDX === 'number' && products.length > 0) {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () { openGalleryModal(window.OPEN_PRODUCT_IDX); }, 200);
    });
  }

  // ── Gallery modal ─────────────────────────────────────────────────
  var galleryProduct = null;
  var gallerySlide = 0;
  var gallerySelSize = null;
  var gallerySelVariantId = null;
  var galleryQty = 1;
  var galleryMaxQty = 99;

  function openGalleryModal(idx) {
    galleryProduct = products[idx];
    gallerySlide = 0;
    gallerySelSize = null;
    gallerySelVariantId = null;
    galleryQty = 1;
    galleryMaxQty = 99;

    el('galleryErr').textContent = '';
    el('galleryAddBtn').disabled = true;
    el('galleryQtyRow').style.display = 'none';
    el('galleryQtyVal').textContent = '1';
    el('galleryTitle').textContent = galleryProduct.name;
    el('galleryPrice').textContent = galleryProduct.price;
    el('galleryDesc').textContent = galleryProduct.desc || '';

    // Build slides
    var track = el('galleryTrack');
    track.innerHTML = '';
    var imgs = galleryProduct.images.length > 0 ? galleryProduct.images : [];
    if (imgs.length === 0) {
      var emptySlide = document.createElement('div');
      emptySlide.className = 'gallery-slide';
      emptySlide.innerHTML = '<div class="gallery-swatch" style="background:#111"><span style="font-size:3rem;color:rgba(255,255,255,.18)">★</span></div>';
      track.appendChild(emptySlide);
    } else {
      imgs.forEach(function (url) {
        var slide = document.createElement('div');
        slide.className = 'gallery-slide';
        var isVid = /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url);
        slide.innerHTML = isVid
          ? '<video src="' + url + '" autoplay muted loop playsinline></video>'
          : '<img src="' + url + '" alt="">';
        track.appendChild(slide);
      });
    }

    var total = Math.max(imgs.length, 1);
    var showNav = total > 1;
    el('galleryPrev').style.display = showNav ? 'flex' : 'none';
    el('galleryNext').style.display = showNav ? 'flex' : 'none';

    var dotsEl = el('galleryDots');
    dotsEl.innerHTML = '';
    if (showNav) {
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('button');
        dot.className = 'gallery-dot' + (d === 0 ? ' on' : '');
        (function (n) { dot.addEventListener('click', function () { gotoSlide(n); }); })(d);
        dotsEl.appendChild(dot);
      }
    }

    // Size buttons
    var sizeGrid = el('gallerySizeGrid');
    sizeGrid.innerHTML = '';
    var inv = galleryProduct.sizeInventory || {};
    SIZES.forEach(function (sz) {
      var avail = typeof inv[sz] === 'number' ? inv[sz] : (galleryProduct.available ? 99 : 0);
      var soldOut = avail === 0;
      var btn = document.createElement('button');
      btn.className = 'size-btn' + (soldOut ? ' size-sold-out' : '');
      btn.textContent = sz;
      btn.disabled = soldOut;
      if (!soldOut) {
        btn.addEventListener('click', function () {
          sizeGrid.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('sel'); });
          btn.classList.add('sel');
          gallerySelSize = sz;
          gallerySelVariantId = (galleryProduct.variantMap || {})[sz] || null;
          galleryMaxQty = (typeof inv[sz] === 'number' && inv[sz] > 0) ? inv[sz] : 99;
          galleryQty = 1;
          el('galleryQtyVal').textContent = '1';
          el('galleryQtyMinus').disabled = true;
          el('galleryQtyPlus').disabled = galleryMaxQty <= 1;
          el('galleryQtyStock').textContent = '';
          el('galleryQtyRow').style.display = 'flex';
          el('galleryAddBtn').disabled = false;
          el('galleryErr').textContent = '';
        });
      }
      sizeGrid.appendChild(btn);
    });

    gotoSlide(0);
    el('galleryModal').classList.add('open');
  }

  function gotoSlide(n) {
    var track = el('galleryTrack');
    var slides = track.querySelectorAll('.gallery-slide');
    if (!slides.length) return;
    gallerySlide = Math.max(0, Math.min(n, slides.length - 1));
    track.style.transform = 'translateX(-' + (gallerySlide * 100) + '%)';
    document.querySelectorAll('#galleryDots .gallery-dot').forEach(function (d, i) {
      d.classList.toggle('on', i === gallerySlide);
    });
    el('galleryPrev').disabled = gallerySlide === 0;
    el('galleryNext').disabled = gallerySlide === slides.length - 1;
    track.querySelectorAll('video').forEach(function (v, i) {
      if (i === gallerySlide) { try { v.play(); } catch (e) {} }
      else { v.pause(); }
    });
  }

  el('galleryPrev').addEventListener('click', function () { gotoSlide(gallerySlide - 1); });
  el('galleryNext').addEventListener('click', function () { gotoSlide(gallerySlide + 1); });
  el('galleryCloseBtn').addEventListener('click', closeGallery);
  el('galleryModal').addEventListener('click', function (e) { if (e.target === this) closeGallery(); });
  function closeGallery() { el('galleryModal').classList.remove('open'); }

  el('galleryQtyMinus').addEventListener('click', function () {
    if (galleryQty > 1) {
      galleryQty--;
      el('galleryQtyVal').textContent = String(galleryQty);
      el('galleryQtyMinus').disabled = galleryQty <= 1;
      el('galleryQtyPlus').disabled = galleryQty >= galleryMaxQty;
    }
  });
  el('galleryQtyPlus').addEventListener('click', function () {
    if (galleryQty < galleryMaxQty) {
      galleryQty++;
      el('galleryQtyVal').textContent = String(galleryQty);
      el('galleryQtyMinus').disabled = galleryQty <= 1;
      el('galleryQtyPlus').disabled = galleryQty >= galleryMaxQty;
      el('galleryQtyStock').textContent = (galleryQty >= galleryMaxQty && galleryMaxQty < 99) ? "(that's all we have in this size)" : '';
    }
  });

  el('galleryAddBtn').addEventListener('click', function () {
    if (!gallerySelSize) { el('galleryErr').textContent = 'Please select a size.'; return; }
    var variantId = gallerySelVariantId;
    if (!variantId) { el('galleryErr').textContent = 'This size is unavailable.'; return; }
    var btn = el('galleryAddBtn');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    shopifyAddToCart(variantId, galleryQty, function (err) {
      if (err) {
        btn.disabled = false;
        btn.textContent = '★ Add to Cart';
        el('galleryErr').textContent = 'Could not add to cart. Please try again.';
        return;
      }
      closeGallery();
      openCart();
    });
  });

  // ── GA4 ecommerce helper ──────────────────────────────────────────
  function ga4Event(eventName, params) {
    if (typeof gtag === 'function' && window.__GA4_ID && window.__GA4_ECOMMERCE) {
      gtag('event', eventName, params);
    }
  }

  // ── Shopify Cart API ──────────────────────────────────────────────
  function shopifyAddToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function (item) {
        // GA4 add_to_cart event
        if (item) {
          ga4Event('add_to_cart', {
            currency: item.currency || 'USD',
            value: ((item.price || 0) / 100) * (quantity || 1),
            items: [{
              item_id: String(item.product_id || variantId),
              item_name: item.product_title || item.title || '',
              item_variant: item.variant_title || '',
              price: (item.price || 0) / 100,
              quantity: quantity || 1,
            }],
          });
        }
        if (callback) callback(null);
      })
      .catch(function (err) { if (callback) callback(err); });
  }

  function shopifyGetCart(callback) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (callback) callback(null, cart); })
      .catch(function (err) { if (callback) callback(err, null); });
  }

  function shopifyChangeItem(key, quantity, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (callback) callback(null, cart); })
      .catch(function (err) { if (callback) callback(err, null); });
  }

  // ── Cart Drawer ───────────────────────────────────────────────────
  function openCart() {
    el('cartDrawer').classList.add('open');
    el('cartOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }

  function closeCart() {
    el('cartDrawer').classList.remove('open');
    el('cartOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  el('cartToggle').addEventListener('click', openCart);
  el('cartClose').addEventListener('click', closeCart);
  el('cartOverlay').addEventListener('click', closeCart);

  function loadCart() {
    el('cartBody').innerHTML = '<div class="cart-spinner"><div class="spinner"></div></div>';
    el('cartFooter').style.display = 'none';
    shopifyGetCart(function (err, cart) {
      if (err || !cart) {
        el('cartBody').innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">★</div><div>Could not load cart</div></div>';
        return;
      }
      renderCartFromShopify(cart);
    });
  }

  function renderCartFromShopify(cart) {
    var body = el('cartBody');
    var footer = el('cartFooter');
    updateCartBadge(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<div class="cart-empty-icon">★</div>' +
        '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:1.1rem;letter-spacing:.1em;margin-bottom:8px">Your cart is empty</div>' +
        '<div style="font-size:.85rem;color:var(--muted)">Add pieces to get your membership started</div>' +
        '</div>';
      footer.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var priceDisplay = '$' + (item.price / 100).toFixed(2);
      var imgHtml = item.image
        ? '<div class="cart-item-thumb"><img src="' + item.image + '" alt="' + item.product_title + '"></div>'
        : '<div class="cart-item-thumb" style="display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.2);font-size:1.5rem">★</div>';
      html +=
        '<div class="cart-item" data-key="' + item.key + '">' +
        imgHtml +
        '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        '<div class="cart-item-color">Size: ' + (item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>' +
        '<div class="cart-item-qty">' +
        '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
        '<span class="qty-val">' + item.quantity + '</span>' +
        '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
        '<span class="cart-item-price">' + priceDisplay + '</span>' +
        '</div>' +
        '<button class="cart-remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    var total = '$' + (cart.total_price / 100).toFixed(2);
    el('cartTotal').textContent = total;
    footer.style.display = 'block';

    body.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if (qty < 0) qty = 0;
        shopifyChangeItem(key, qty, function (err, updatedCart) {
          if (!err && updatedCart) renderCartFromShopify(updatedCart);
        });
      });
    });
    body.querySelectorAll('.cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        shopifyChangeItem(btn.getAttribute('data-key'), 0, function (err, updatedCart) {
          if (!err && updatedCart) renderCartFromShopify(updatedCart);
        });
      });
    });
  }

  function updateCartBadge(count) {
    var countEl = el('cartCount');
    if (count > 0) {
      countEl.textContent = count;
      countEl.style.display = 'flex';
    } else {
      countEl.style.display = 'none';
    }
  }

  el('checkoutBtn').addEventListener('click', function () {
    window.location.href = '/checkout';
  });

  shopifyGetCart(function (err, cart) {
    if (!err && cart) updateCartBadge(cart.item_count || 0);
  });

  // ── UTM / analytics tracking ──────────────────────────────────────
  (function () {
    function getCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
    function setCookie(n, v, d) { var x = new Date(); x.setTime(x.getTime() + d * 864e5); document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + x.toUTCString() + ';path=/;SameSite=Lax'; }
    function genId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
    if (!getCookie('_mbr_vid')) setCookie('_mbr_vid', genId(), 365);
    if (!getCookie('_mbr_fv')) setCookie('_mbr_fv', Date.now(), 365);
    setCookie('_mbr_lv', Date.now(), 365);
    if (document.referrer && !getCookie('_mbr_ref')) setCookie('_mbr_ref', document.referrer, 30);
    var p = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = p.get(k); if (v) setCookie('_mbr_' + k, v, 30);
    });
    if (window.fbq) window.fbq('track', 'ViewContent', { content_name: 'MEMBERS Store' });
    if (window.gtag) window.gtag('event', 'page_view');
  })();

  // ── Utility ───────────────────────────────────────────────────────
  function el(id) { return document.getElementById(id); }
})();
